/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Machines_Config_ErrorInputs */

const vi_tea_machines_config_error = /** @type {(inputs: Tea_Machines_Config_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máy vò chưa được cấu hình đúng với SmartLab. Đã báo quản trị.`)
};

/**

* @param {Tea_Machines_Config_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_machines_config_error = /** @type {((inputs?: Tea_Machines_Config_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Machines_Config_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_machines_config_error(inputs)
});